import React from 'react'

// Components
import {
  Button,
  Link,
  Text,
  useModalContext,
  useResponsiveDropdown,
} from '@sketch/components'
import BillingInfoTable from '../BillingInfoTable'
import { ChangeBillingPlanModal } from 'modules/workspace/modals/ChangeBillingPlanModal'

// Utils
import { useFlag } from '@sketch/modules-common'

// GQL Types
import {
  BillingPlanFragment,
  BillingSeatsInfoFragment,
  PaymentDetailsFragment,
} from '@sketch/gql-types'

const YearlyToMonthlyWarning = () => {
  return (
    <Text textStyle="copy.tertiary.standard.C" mx={3}>
      To change to a Monthly subscription, please{' '}
      <Link
        href="https://www.sketch.com/support/contact/"
        external
        isUnderlined
        variant="primary"
        title="Contact Us"
      >
        contact our support team
      </Link>
    </Text>
  )
}

interface EditButtonProps {
  customerId: string
  isWorkspaceOnTrial: boolean
  currentPlan?: BillingPlanFragment
  seats: BillingSeatsInfoFragment
  paymentDetails?: PaymentDetailsFragment
  onWorkspaceSettingRefresh: () => Promise<void>
}

export const EditButton: React.FC<EditButtonProps> = ({
  customerId,
  isWorkspaceOnTrial,
  currentPlan,
  seats,
  paymentDetails,
  onWorkspaceSettingRefresh,
}) => {
  const isMonthlyToYearlyConversionOn = useFlag('convert-monthly-to-yearly')
  const { showModal } = useModalContext()
  const [
    yearlyToMonthlyAlertContent,
    yearlyToMonthlyProps,
  ] = useResponsiveDropdown({
    dropdown: YearlyToMonthlyWarning,
    placement: 'right',
    showOnHover: true,
    dropdownStyle: {
      width: '240px',
    },
  })

  if (!isMonthlyToYearlyConversionOn) {
    return null
  }

  if (isWorkspaceOnTrial || currentPlan?.product !== 'TEAMS') {
    return null
  }

  return (
    <BillingInfoTable.Cell>
      {currentPlan.type === 'MONTHLY' ? (
        <Button
          variant="secondary"
          size="32"
          onClick={() =>
            showModal(ChangeBillingPlanModal, {
              currentPlan,
              customerId,
              onWorkspaceSettingRefresh,
              seats,
              paymentDetails,
            })
          }
        >
          Edit&hellip;
        </Button>
      ) : (
        <div {...yearlyToMonthlyProps}>
          <Button variant="secondary" size="32" disabled>
            Edit&hellip;
          </Button>
          {yearlyToMonthlyAlertContent}
        </div>
      )}
    </BillingInfoTable.Cell>
  )
}
